import script from "./PaymentLinkSuccessDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./PaymentLinkSuccessDialog.vue?vue&type=script&setup=true&lang=js"

import "./PaymentLinkSuccessDialog.vue?vue&type=style&index=0&id=610981e1&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-610981e1"]])

export default __exports__